import axios from "axios";

// export const API_BASE_URL = "http://localhost:5001";
export const API_BASE_URL = "https://docusignapi.innovations.guru";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth-token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token is invalid, redirect to login
      localStorage.removeItem("auth-token");
      localStorage.removeItem("auth-user");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

// User API
export const userAPI = {
  getAll: () => api.get("/users"),
  getById: (id: string) => api.get(`/users/${id}`),
  create: (data: any) => api.post("/users", data),
  update: (id: string, data: any) => api.patch(`/users/${id}`, data),
  delete: (id: string) => api.delete(`/users/${id}`),
};

// Document API
export const documentAPI = {
  getAll: () => api.get("/documents"),
  getActive: () => api.get("/documents/active"),
  getById: (id: string) => api.get(`/documents/${id}`),
  create: (formData: FormData) => {
    const token = localStorage.getItem("auth-token");
    return api.post("/documents", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    });
  },
  update: (id: string, data: any) => api.patch(`/documents/${id}`, data),
  delete: (id: string) => api.delete(`/documents/${id}`),
  getByType: (type: string) => api.get(`/documents/for/${type}`),
};

// Signature API
export const signatureAPI = {
  getAll: () => api.get("/signatures"),
  getByUser: (userId: string) => api.get(`/signatures/user/${userId}`),
  getByDocument: (documentId: string) =>
    api.get(`/signatures/document/${documentId}`),
  getStats: () => api.get("/signatures/stats"),
};

// DocuSign API
export const docusignAPI = {
  assignDocuments: (data: {
    userId: string;
    documentIds: string[];
    subject: string;
    message: string;
  }) => api.post("/docusign/assign", data),
};

export default api;
